/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  DatabaseContentPage,
  DatabaseEmailTemplateSpecification,
  DatabaseEntryFileMetaData,
  DatabaseField,
  DatabasePages,
  DatabasePermissionMatrix,
  DatabaseTemplate,
  DatabaseTemplateCategory,
  TemplatePushToEnvRequest,
  TemplatePushToEnvResponse,
  UpdateFieldRequest,
  UpdateTemplateMappingsRequestInner,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    DatabaseContentPageFromJSON,
    DatabaseContentPageToJSON,
    DatabaseEmailTemplateSpecificationFromJSON,
    DatabaseEmailTemplateSpecificationToJSON,
    DatabaseEntryFileMetaDataFromJSON,
    DatabaseEntryFileMetaDataToJSON,
    DatabaseFieldFromJSON,
    DatabaseFieldToJSON,
    DatabasePagesFromJSON,
    DatabasePagesToJSON,
    DatabasePermissionMatrixFromJSON,
    DatabasePermissionMatrixToJSON,
    DatabaseTemplateFromJSON,
    DatabaseTemplateToJSON,
    DatabaseTemplateCategoryFromJSON,
    DatabaseTemplateCategoryToJSON,
    TemplatePushToEnvRequestFromJSON,
    TemplatePushToEnvRequestToJSON,
    TemplatePushToEnvResponseFromJSON,
    TemplatePushToEnvResponseToJSON,
    UpdateFieldRequestFromJSON,
    UpdateFieldRequestToJSON,
    UpdateTemplateMappingsRequestInnerFromJSON,
    UpdateTemplateMappingsRequestInnerToJSON,
} from '../models';

export interface CopyDatabaseTemplateRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
}

export interface CreateDatabaseTemplateRequest {
    xApplicationScope: ApplicationScope;
    databaseTemplate: DatabaseTemplate;
}

export interface CreateTemplateAttachmentRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    databaseEntryFileMetaData?: DatabaseEntryFileMetaData;
}

export interface CreateTemplateContentPageRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    databaseContentPage?: DatabaseContentPage;
}

export interface CreateTemplateFieldRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    databaseField: DatabaseField;
}

export interface DeleteDatabaseTemplateRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
}

export interface DeleteTemplateAttachmentRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    attachmentId: string;
}

export interface DeleteTemplateContentPageRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    pageId: string;
}

export interface DeleteTemplateFieldRequest {
    xApplicationScope: ApplicationScope;
    fieldId: string;
    templateId: string;
}

export interface ExportDatabaseTemplateZipRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
}

export interface GetDatabaseTemplateRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
}

export interface GetDatabaseTemplateCategoriesRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetDatabaseTemplateChildrenRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
}

export interface GetDatabaseTemplateImageRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
}

export interface GetDatabaseTemplateMailTemplatesRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
}

export interface GetDatabaseTemplatesRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetTemplateAttachmentRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    attachmentId: string;
}

export interface GetTemplateContentPagesRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
}

export interface GetTemplateFieldRequest {
    xApplicationScope: ApplicationScope;
    fieldId: string;
    templateId: string;
}

export interface GetTemplateFieldsRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
}

export interface GetTemplatePermissionsRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
}

export interface ImportDatabaseTemplateZipRequest {
    xApplicationScope: ApplicationScope;
    body: Blob;
    overwrite?: boolean;
}

export interface PartiallyUpdateDatabaseTemplateRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    databaseTemplate?: DatabaseTemplate;
}

export interface PushDatabaseTemplateToEnvRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    templatePushToEnvRequest: TemplatePushToEnvRequest;
}

export interface UpdateDatabaseTemplateMailTemplatesRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    databaseEmailTemplateSpecification: Array<DatabaseEmailTemplateSpecification>;
}

export interface UpdateTemplateAttachmentRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    attachmentId: string;
    databaseEntryFileMetaData: DatabaseEntryFileMetaData;
}

export interface UpdateTemplateContentPageRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    pageId: string;
    databaseContentPage?: DatabaseContentPage;
}

export interface UpdateTemplateContentPagesOrderRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    requestBody: Array<string>;
}

export interface UpdateTemplateFieldRequest {
    xApplicationScope: ApplicationScope;
    fieldId: string;
    templateId: string;
    updateFieldRequest?: UpdateFieldRequest;
}

export interface UpdateTemplateFieldsOrderRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    requestBody: Array<string>;
}

export interface UpdateTemplateMappingsRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    updateTemplateMappingsRequestInner?: Array<UpdateTemplateMappingsRequestInner>;
}

export interface UpdateTemplatePagesRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    databasePages?: DatabasePages;
}

export interface UpdateTemplatePermissionsRequest {
    xApplicationScope: ApplicationScope;
    templateId: string;
    databasePermissionMatrix?: DatabasePermissionMatrix;
}

/**
 * 
 */
export class DatabaseTemplateControllerApi extends runtime.BaseAPI {

    /**
     * copys the database template
     */
    async copyDatabaseTemplateRaw(requestParameters: CopyDatabaseTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseTemplate>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling copyDatabaseTemplate.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling copyDatabaseTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/copy`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseTemplateFromJSON(jsonValue));
    }

    /**
     * copys the database template
     */
    async copyDatabaseTemplate(requestParameters: CopyDatabaseTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseTemplate> {
        const response = await this.copyDatabaseTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create a database template
     * create a database template
     */
    async createDatabaseTemplateRaw(requestParameters: CreateDatabaseTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseTemplate>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createDatabaseTemplate.');
        }

        if (requestParameters.databaseTemplate === null || requestParameters.databaseTemplate === undefined) {
            throw new runtime.RequiredError('databaseTemplate','Required parameter requestParameters.databaseTemplate was null or undefined when calling createDatabaseTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseTemplateToJSON(requestParameters.databaseTemplate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseTemplateFromJSON(jsonValue));
    }

    /**
     * create a database template
     * create a database template
     */
    async createDatabaseTemplate(requestParameters: CreateDatabaseTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseTemplate> {
        const response = await this.createDatabaseTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create template attachment
     * Create template attachment
     */
    async createTemplateAttachmentRaw(requestParameters: CreateTemplateAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntryFileMetaData>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createTemplateAttachment.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling createTemplateAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/attachments`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseEntryFileMetaDataToJSON(requestParameters.databaseEntryFileMetaData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntryFileMetaDataFromJSON(jsonValue));
    }

    /**
     * create template attachment
     * Create template attachment
     */
    async createTemplateAttachment(requestParameters: CreateTemplateAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntryFileMetaData> {
        const response = await this.createTemplateAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create template content page
     * Create template content page
     */
    async createTemplateContentPageRaw(requestParameters: CreateTemplateContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseContentPage>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createTemplateContentPage.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling createTemplateContentPage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/content-pages`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseContentPageToJSON(requestParameters.databaseContentPage),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseContentPageFromJSON(jsonValue));
    }

    /**
     * create template content page
     * Create template content page
     */
    async createTemplateContentPage(requestParameters: CreateTemplateContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseContentPage> {
        const response = await this.createTemplateContentPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create a field
     */
    async createTemplateFieldRaw(requestParameters: CreateTemplateFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseField>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createTemplateField.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling createTemplateField.');
        }

        if (requestParameters.databaseField === null || requestParameters.databaseField === undefined) {
            throw new runtime.RequiredError('databaseField','Required parameter requestParameters.databaseField was null or undefined when calling createTemplateField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/fields`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseFieldToJSON(requestParameters.databaseField),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFieldFromJSON(jsonValue));
    }

    /**
     * create a field
     */
    async createTemplateField(requestParameters: CreateTemplateFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseField> {
        const response = await this.createTemplateFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * delete database template
     * delete database template
     */
    async deleteDatabaseTemplateRaw(requestParameters: DeleteDatabaseTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteDatabaseTemplate.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling deleteDatabaseTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete database template
     * delete database template
     */
    async deleteDatabaseTemplate(requestParameters: DeleteDatabaseTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDatabaseTemplateRaw(requestParameters, initOverrides);
    }

    /**
     * Delete template attachment
     * Delete template attachment
     */
    async deleteTemplateAttachmentRaw(requestParameters: DeleteTemplateAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteTemplateAttachment.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling deleteTemplateAttachment.');
        }

        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId','Required parameter requestParameters.attachmentId was null or undefined when calling deleteTemplateAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/attachments/{attachmentId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete template attachment
     * Delete template attachment
     */
    async deleteTemplateAttachment(requestParameters: DeleteTemplateAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTemplateAttachmentRaw(requestParameters, initOverrides);
    }

    /**
     * Delete template content page
     * Delete template content page
     */
    async deleteTemplateContentPageRaw(requestParameters: DeleteTemplateContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteTemplateContentPage.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling deleteTemplateContentPage.');
        }

        if (requestParameters.pageId === null || requestParameters.pageId === undefined) {
            throw new runtime.RequiredError('pageId','Required parameter requestParameters.pageId was null or undefined when calling deleteTemplateContentPage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/content-pages/{pageId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))).replace(`{${"pageId"}}`, encodeURIComponent(String(requestParameters.pageId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete template content page
     * Delete template content page
     */
    async deleteTemplateContentPage(requestParameters: DeleteTemplateContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTemplateContentPageRaw(requestParameters, initOverrides);
    }

    /**
     * delete database field
     * delete database field
     */
    async deleteTemplateFieldRaw(requestParameters: DeleteTemplateFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteTemplateField.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling deleteTemplateField.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling deleteTemplateField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/fields/{fieldId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))).replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete database field
     * delete database field
     */
    async deleteTemplateField(requestParameters: DeleteTemplateFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTemplateFieldRaw(requestParameters, initOverrides);
    }

    /**
     * Exports a designvorlage as a portable ZIP bundle including its category, all content pages, and all media files. The bundle can later be imported on another environment via import-zip. 
     * export a designvorlage as ZIP bundle
     */
    async exportDatabaseTemplateZipRaw(requestParameters: ExportDatabaseTemplateZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling exportDatabaseTemplateZip.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling exportDatabaseTemplateZip.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/export-zip`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Exports a designvorlage as a portable ZIP bundle including its category, all content pages, and all media files. The bundle can later be imported on another environment via import-zip. 
     * export a designvorlage as ZIP bundle
     */
    async exportDatabaseTemplateZip(requestParameters: ExportDatabaseTemplateZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportDatabaseTemplateZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database template by id
     * get database template by id
     */
    async getDatabaseTemplateRaw(requestParameters: GetDatabaseTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseTemplate>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseTemplate.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling getDatabaseTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseTemplateFromJSON(jsonValue));
    }

    /**
     * get database template by id
     * get database template by id
     */
    async getDatabaseTemplate(requestParameters: GetDatabaseTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseTemplate> {
        const response = await this.getDatabaseTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all database template categories
     * get all database template categories
     */
    async getDatabaseTemplateCategoriesRaw(requestParameters: GetDatabaseTemplateCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseTemplateCategory>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseTemplateCategories.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseTemplateCategoryFromJSON));
    }

    /**
     * get all database template categories
     * get all database template categories
     */
    async getDatabaseTemplateCategories(requestParameters: GetDatabaseTemplateCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseTemplateCategory>> {
        const response = await this.getDatabaseTemplateCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database template children
     * get database template children
     */
    async getDatabaseTemplateChildrenRaw(requestParameters: GetDatabaseTemplateChildrenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseTemplate>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseTemplateChildren.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling getDatabaseTemplateChildren.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/children`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseTemplateFromJSON));
    }

    /**
     * get database template children
     * get database template children
     */
    async getDatabaseTemplateChildren(requestParameters: GetDatabaseTemplateChildrenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseTemplate>> {
        const response = await this.getDatabaseTemplateChildrenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database template image
     * get database template image
     */
    async getDatabaseTemplateImageRaw(requestParameters: GetDatabaseTemplateImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseTemplateImage.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling getDatabaseTemplateImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/image`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get database template image
     * get database template image
     */
    async getDatabaseTemplateImage(requestParameters: GetDatabaseTemplateImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getDatabaseTemplateImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get mail templates by database template id
     * get mail templates by database template id
     */
    async getDatabaseTemplateMailTemplatesRaw(requestParameters: GetDatabaseTemplateMailTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseEmailTemplateSpecification>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseTemplateMailTemplates.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling getDatabaseTemplateMailTemplates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/mail-templates`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseEmailTemplateSpecificationFromJSON));
    }

    /**
     * get mail templates by database template id
     * get mail templates by database template id
     */
    async getDatabaseTemplateMailTemplates(requestParameters: GetDatabaseTemplateMailTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseEmailTemplateSpecification>> {
        const response = await this.getDatabaseTemplateMailTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all database templates
     * get all database templates
     */
    async getDatabaseTemplatesRaw(requestParameters: GetDatabaseTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseTemplate>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseTemplates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseTemplateFromJSON));
    }

    /**
     * get all database templates
     * get all database templates
     */
    async getDatabaseTemplates(requestParameters: GetDatabaseTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseTemplate>> {
        const response = await this.getDatabaseTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get template attachment
     * Get template attachment
     */
    async getTemplateAttachmentRaw(requestParameters: GetTemplateAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getTemplateAttachment.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling getTemplateAttachment.');
        }

        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId','Required parameter requestParameters.attachmentId was null or undefined when calling getTemplateAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/attachments/{attachmentId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get template attachment
     * Get template attachment
     */
    async getTemplateAttachment(requestParameters: GetTemplateAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getTemplateAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get template content pages
     * Get template content pages
     */
    async getTemplateContentPagesRaw(requestParameters: GetTemplateContentPagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseContentPage>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getTemplateContentPages.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling getTemplateContentPages.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/content-pages`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseContentPageFromJSON));
    }

    /**
     * get template content pages
     * Get template content pages
     */
    async getTemplateContentPages(requestParameters: GetTemplateContentPagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseContentPage>> {
        const response = await this.getTemplateContentPagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get field by id
     * get field by id
     */
    async getTemplateFieldRaw(requestParameters: GetTemplateFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseField>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getTemplateField.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling getTemplateField.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling getTemplateField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/fields/{fieldId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))).replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFieldFromJSON(jsonValue));
    }

    /**
     * get field by id
     * get field by id
     */
    async getTemplateField(requestParameters: GetTemplateFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseField> {
        const response = await this.getTemplateFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get fields by database template id
     * get fields by database template id
     */
    async getTemplateFieldsRaw(requestParameters: GetTemplateFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseField>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getTemplateFields.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling getTemplateFields.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/fields`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseFieldFromJSON));
    }

    /**
     * get fields by database template id
     * get fields by database template id
     */
    async getTemplateFields(requestParameters: GetTemplateFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseField>> {
        const response = await this.getTemplateFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get permission matrix for a database template
     * get permission matrix for a database template
     */
    async getTemplatePermissionsRaw(requestParameters: GetTemplatePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabasePermissionMatrix>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getTemplatePermissions.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling getTemplatePermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/permissions`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabasePermissionMatrixFromJSON(jsonValue));
    }

    /**
     * get permission matrix for a database template
     * get permission matrix for a database template
     */
    async getTemplatePermissions(requestParameters: GetTemplatePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabasePermissionMatrix> {
        const response = await this.getTemplatePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Imports a designvorlage that was exported from another environment (Dev/Prod). The bundle contains the template, its category, all content pages, and all media files. Before applying, the bundle\'s uiTemplate is checked against the local list of supported template types. If the bundle\'s templateCanonicalId already exists, the call returns 409 unless overwrite=true is set. 
     * import a designvorlage from a previously exported ZIP bundle
     */
    async importDatabaseTemplateZipRaw(requestParameters: ImportDatabaseTemplateZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseTemplate>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling importDatabaseTemplateZip.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling importDatabaseTemplateZip.');
        }

        const queryParameters: any = {};

        if (requestParameters.overwrite !== undefined) {
            queryParameters['overwrite'] = requestParameters.overwrite;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/zip';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/import-zip`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseTemplateFromJSON(jsonValue));
    }

    /**
     * Imports a designvorlage that was exported from another environment (Dev/Prod). The bundle contains the template, its category, all content pages, and all media files. Before applying, the bundle\'s uiTemplate is checked against the local list of supported template types. If the bundle\'s templateCanonicalId already exists, the call returns 409 unless overwrite=true is set. 
     * import a designvorlage from a previously exported ZIP bundle
     */
    async importDatabaseTemplateZip(requestParameters: ImportDatabaseTemplateZipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseTemplate> {
        const response = await this.importDatabaseTemplateZipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * partially update database template
     * partially update database template
     */
    async partiallyUpdateDatabaseTemplateRaw(requestParameters: PartiallyUpdateDatabaseTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseTemplate>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling partiallyUpdateDatabaseTemplate.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling partiallyUpdateDatabaseTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseTemplateToJSON(requestParameters.databaseTemplate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseTemplateFromJSON(jsonValue));
    }

    /**
     * partially update database template
     * partially update database template
     */
    async partiallyUpdateDatabaseTemplate(requestParameters: PartiallyUpdateDatabaseTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseTemplate> {
        const response = await this.partiallyUpdateDatabaseTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Server-to-server transfer: exports the template locally (same logic as export-zip) and POSTs it to the target backend\'s /database-templates/import-zip endpoint. Avoids the manual download-then-upload dance. Caller supplies the target API base URL and a fresh Bearer token for the target environment.  Returns the id + name of the template that was created (or updated) on the target. 
     * push a designvorlage directly to another environment (DEV → PROD or vice versa)
     */
    async pushDatabaseTemplateToEnvRaw(requestParameters: PushDatabaseTemplateToEnvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TemplatePushToEnvResponse>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling pushDatabaseTemplateToEnv.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling pushDatabaseTemplateToEnv.');
        }

        if (requestParameters.templatePushToEnvRequest === null || requestParameters.templatePushToEnvRequest === undefined) {
            throw new runtime.RequiredError('templatePushToEnvRequest','Required parameter requestParameters.templatePushToEnvRequest was null or undefined when calling pushDatabaseTemplateToEnv.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/push-to-env`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TemplatePushToEnvRequestToJSON(requestParameters.templatePushToEnvRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TemplatePushToEnvResponseFromJSON(jsonValue));
    }

    /**
     * Server-to-server transfer: exports the template locally (same logic as export-zip) and POSTs it to the target backend\'s /database-templates/import-zip endpoint. Avoids the manual download-then-upload dance. Caller supplies the target API base URL and a fresh Bearer token for the target environment.  Returns the id + name of the template that was created (or updated) on the target. 
     * push a designvorlage directly to another environment (DEV → PROD or vice versa)
     */
    async pushDatabaseTemplateToEnv(requestParameters: PushDatabaseTemplateToEnvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TemplatePushToEnvResponse> {
        const response = await this.pushDatabaseTemplateToEnvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update mail templates by database template id
     * update mail templates by database template id
     */
    async updateDatabaseTemplateMailTemplatesRaw(requestParameters: UpdateDatabaseTemplateMailTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseEmailTemplateSpecification>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateDatabaseTemplateMailTemplates.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling updateDatabaseTemplateMailTemplates.');
        }

        if (requestParameters.databaseEmailTemplateSpecification === null || requestParameters.databaseEmailTemplateSpecification === undefined) {
            throw new runtime.RequiredError('databaseEmailTemplateSpecification','Required parameter requestParameters.databaseEmailTemplateSpecification was null or undefined when calling updateDatabaseTemplateMailTemplates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/mail-templates`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.databaseEmailTemplateSpecification.map(DatabaseEmailTemplateSpecificationToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseEmailTemplateSpecificationFromJSON));
    }

    /**
     * update mail templates by database template id
     * update mail templates by database template id
     */
    async updateDatabaseTemplateMailTemplates(requestParameters: UpdateDatabaseTemplateMailTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseEmailTemplateSpecification>> {
        const response = await this.updateDatabaseTemplateMailTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update template attachment
     * update template attachment
     */
    async updateTemplateAttachmentRaw(requestParameters: UpdateTemplateAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntryFileMetaData>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateTemplateAttachment.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling updateTemplateAttachment.');
        }

        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId','Required parameter requestParameters.attachmentId was null or undefined when calling updateTemplateAttachment.');
        }

        if (requestParameters.databaseEntryFileMetaData === null || requestParameters.databaseEntryFileMetaData === undefined) {
            throw new runtime.RequiredError('databaseEntryFileMetaData','Required parameter requestParameters.databaseEntryFileMetaData was null or undefined when calling updateTemplateAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/attachments/{attachmentId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseEntryFileMetaDataToJSON(requestParameters.databaseEntryFileMetaData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntryFileMetaDataFromJSON(jsonValue));
    }

    /**
     * update template attachment
     * update template attachment
     */
    async updateTemplateAttachment(requestParameters: UpdateTemplateAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntryFileMetaData> {
        const response = await this.updateTemplateAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update template content page
     * Update template content page
     */
    async updateTemplateContentPageRaw(requestParameters: UpdateTemplateContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseContentPage>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateTemplateContentPage.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling updateTemplateContentPage.');
        }

        if (requestParameters.pageId === null || requestParameters.pageId === undefined) {
            throw new runtime.RequiredError('pageId','Required parameter requestParameters.pageId was null or undefined when calling updateTemplateContentPage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/content-pages/{pageId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))).replace(`{${"pageId"}}`, encodeURIComponent(String(requestParameters.pageId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseContentPageToJSON(requestParameters.databaseContentPage),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseContentPageFromJSON(jsonValue));
    }

    /**
     * Update template content page
     * Update template content page
     */
    async updateTemplateContentPage(requestParameters: UpdateTemplateContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseContentPage> {
        const response = await this.updateTemplateContentPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update template content pages order
     */
    async updateTemplateContentPagesOrderRaw(requestParameters: UpdateTemplateContentPagesOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateTemplateContentPagesOrder.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling updateTemplateContentPagesOrder.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling updateTemplateContentPagesOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/content-pages`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * update template content pages order
     */
    async updateTemplateContentPagesOrder(requestParameters: UpdateTemplateContentPagesOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.updateTemplateContentPagesOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update database field
     * update database field
     */
    async updateTemplateFieldRaw(requestParameters: UpdateTemplateFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseField>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateTemplateField.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling updateTemplateField.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling updateTemplateField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/fields/{fieldId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))).replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFieldRequestToJSON(requestParameters.updateFieldRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFieldFromJSON(jsonValue));
    }

    /**
     * update database field
     * update database field
     */
    async updateTemplateField(requestParameters: UpdateTemplateFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseField> {
        const response = await this.updateTemplateFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update fields order
     */
    async updateTemplateFieldsOrderRaw(requestParameters: UpdateTemplateFieldsOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseField>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateTemplateFieldsOrder.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling updateTemplateFieldsOrder.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling updateTemplateFieldsOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/fields`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseFieldFromJSON));
    }

    /**
     * update fields order
     */
    async updateTemplateFieldsOrder(requestParameters: UpdateTemplateFieldsOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseField>> {
        const response = await this.updateTemplateFieldsOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update template mappings
     * update template mappings
     */
    async updateTemplateMappingsRaw(requestParameters: UpdateTemplateMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateTemplateMappings.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling updateTemplateMappings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/template-mappings`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateTemplateMappingsRequestInner.map(UpdateTemplateMappingsRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * update template mappings
     * update template mappings
     */
    async updateTemplateMappings(requestParameters: UpdateTemplateMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTemplateMappingsRaw(requestParameters, initOverrides);
    }

    /**
     * update database template pages
     * update database template pages
     */
    async updateTemplatePagesRaw(requestParameters: UpdateTemplatePagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseTemplate>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateTemplatePages.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling updateTemplatePages.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/pages`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DatabasePagesToJSON(requestParameters.databasePages),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseTemplateFromJSON(jsonValue));
    }

    /**
     * update database template pages
     * update database template pages
     */
    async updateTemplatePages(requestParameters: UpdateTemplatePagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseTemplate> {
        const response = await this.updateTemplatePagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update permission matrix for a database template
     * update permission matrix for a database template
     */
    async updateTemplatePermissionsRaw(requestParameters: UpdateTemplatePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabasePermissionMatrix>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateTemplatePermissions.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling updateTemplatePermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/database-templates/{templateId}/permissions`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DatabasePermissionMatrixToJSON(requestParameters.databasePermissionMatrix),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabasePermissionMatrixFromJSON(jsonValue));
    }

    /**
     * update permission matrix for a database template
     * update permission matrix for a database template
     */
    async updateTemplatePermissions(requestParameters: UpdateTemplatePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabasePermissionMatrix> {
        const response = await this.updateTemplatePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
